<!-- 原料商品 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-body custom-class="drawer_box" direction="ltr" size="100%">
            <rawProductsAction v-if="showStatus" ref="rawProductsAction" @drawerCancel="drawerCancel" :actionData="actionData"></rawProductsAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline dis" size="mini" @submit.native.prevent v-if="pageShowData.jurHead">
                    <el-form-item :label="formOneValue.showField" class="pd" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in pageShowData.jurHead.jurconfigform" :key="formOneKey">
                        <el-select v-if="formOneValue.entityField == 'rmmActivestatus'" v-model="getRequestData[formOneValue.entityField]" class="form_codition" size="mini" clearable placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="停用" :value="0"></el-option>
                            <el-option label="启用" :value="1"></el-option>
                        </el-select>
                        <el-date-picker v-else-if="formOneValue.entityField == 'start'" class="form_codition" size="mini" v-model="getRequestData[formOneValue.entityField]" format="yyyy年MM月dd日" value-format="timestamp" type="date"
                            placeholder="选择日期" clearable>
                        </el-date-picker>
                        <el-date-picker v-else-if="formOneValue.entityField == 'end'" class="form_codition" @change="changeTime" size="mini" v-model="getRequestData[formOneValue.entityField]" format="yyyy年MM月dd日" value-format="timestamp"
                            type="date" placeholder="选择日期" clearable>
                        </el-date-picker>
                        <el-select clearable size="mini" class="form_codition" v-else-if="formOneValue.fieldType == 'formatter'" v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
                            <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                        </el-select>
                        <el-input v-else class="form_codition" v-model.trim="getRequestData[formOneValue.entityField]" size="mini" :maxlength="$store.state.inputLength" clearable placeholder="请输入"
                            @keyup.enter.native="searchData"></el-input>
                    </el-form-item>
                    <el-form-item class="pd">
                        <el-button type="primary" icon="el-icon-search" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center" v-loading="tableLoading">
            <el-table size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border @selection-change="selecDataAction" style="width: 100%" highlight-current-row>
                <el-table-column type="selection" width="45" align="center"></el-table-column>
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column v-if="tableValye.isShow == 1" show-overflow-tooltip :min-width="tableValye.fieldWeight" align="center" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
                    :prop="tableValye.entityField" :label="tableValye.showField">
                    <template slot-scope="scope">
                        <span v-if="tableValye.entityField == 'rmmCreatetime'">
                            {{ $common.getLocalTime(scope.row.rmmCreatetime) }}
                        </span>
                        <span v-else-if="tableValye.entityField == 'rmmUpdatetime' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row.rmmUpdatetime) }}
                        </span>
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'rmmActivestatus'" :type="scope.row.rmmActivestatus == 0 ? 'info' : 'success'">
                            {{ scope.row.rmmActivestatus == 0 ? '停用' : '启用' }}
                        </el-tag>
                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
import rawProductsAction from "@/components/rawProductsAction.vue";
export default {
    components: { rawProductsAction },
    data() {
        return {
            tableHeight: 0,
            tableLoading: false,
            showStatus: false,
            actionData: {},
            getRequestData: {
                rmmName: '',
                rmmActivestatus: '',
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            },
            returnData: {
                pages: 0,
                total: 0,
                pageNum: 0,
                list: []
            },
            buttonList: [],
            selectedDataList: [],
            pageShowData: [],
            formDataList: [],
        };
    },
    methods: {
        drawerCancel() {
            this.showStatus = false
            this.getDataList()
        },
        changeTime(val) {
            if (val) {
                this.getRequestData.end = val + 24 * 60 * 60 * 1000 - 1
            }
        },
        getPageInfo() {
            var ss = parent.getMenuInfo(this.$route.path)
            this.getDataTest(ss.jurId)
        },
        async getDataTest(ids) {
            let responseData = await this.$http.getJur({
                ids: [ids]
            })
            if (responseData.status == 200) {
                this.getDataList();
                this.getButtonList();
                this.pageShowData = responseData.result
                this.formDataList = this.pageShowData.jurFormVoList
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        selecDataAction(data) {
            this.selectedDataList = data
        },
        checkSelect() {
            let flag = true
            if (this.returnData.list.length <= 0) {
                this.$message({
                    message: '暂无数据',
                    type: 'error'
                });
                flag = false
            } else if (this.selectedDataList.length <= 0) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                flag = false
            }
            return flag
        },
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: '',
                    }
                    break;
                case 1:
                    if (this.checkSelect()) {
                        if (this.selectedDataList.length > 1) {
                            return this.$message({
                                message: '请选中一条数据修改',
                                type: 'error'
                            });
                        }
                        var dataInfo = JSON.parse(JSON.stringify(this.selectedDataList[0]))
                        this.showStatus = true
                        this.actionData = {
                            cate: 1,
                            formData: this.formDataList,
                            oldData: dataInfo,
                        }
                    }
                    break;
                case 2:
                    this.delDataAction()
                    break;
                case 15:
                    this.openFormDesign()
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },
        async getDataList() {
            this.tableLoading = true
            try {
                let responseData = await this.$http.getRawProduct(this.getRequestData)
                if (responseData.status == 200) {
                    this.returnData.list = responseData.result.list
                    this.returnData.pages = responseData.result.pages
                    this.returnData.total = responseData.result.total
                    this.returnData.pageNum = responseData.result.pageNum
                    this.selectedDataList = []
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            } finally {
                this.tableLoading = false
            }
        },
        delDataAction() {
            if (!this.checkSelect()) return false
            if (this.selectedDataList.length > 1) {
                return this.$message({
                    message: '删除信息只能选择一条数据，请勿多选',
                    type: 'error'
                });
            }
            var dataInfo = this.selectedDataList[0]
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.rmmId]
                }
                let responseData = await this.$http.delRawProduct(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
    },
    created() {
        this.getPageInfo()
    },
    updated() {
        this.tableHeight = this.$common.getTableHeight()
    },
    activated() {
        this.tableHeight = this.$common.getTableHeight()
    },
}
</script>
<style scoped>
.dis {
    display: flex;
    flex-wrap: wrap !important;
}

.page_content_top_line {
    padding-bottom: 0;
}
</style>
